/**
 * @generated by @interxfi/j5-codegen - do not edit */

import { buildMergedRequestInit, makeRequest } from '@interxfi/api-client/request';
import type { IxmUserauthV1SessionServiceWhoamiResponse } from '@interxfi/types';

export async function ixmUserauthV1SessionServiceWhoami(baseUrl: string | undefined, requestInit?: RequestInit): Promise<IxmUserauthV1SessionServiceWhoamiResponse | undefined> { return makeRequest<IxmUserauthV1SessionServiceWhoamiResponse>(...buildMergedRequestInit('GET', baseUrl || '', '/portal/userauth/v1/session/whoami', undefined, requestInit)); }

